angular.module('bb.assets').component('bbFileSearchbar', {
  controller: FileSearchbarController,
  controllerAs: 'vm',
  template: require('./file_searchbar.html'),
  bindings: {
    selectFolder: '<',
  },
});

FileSearchbarController.$inject = ['AssetsService', '$timeout', '$window'];

function FileSearchbarController(AssetsService, $timeout, $window) {
  const vm = this;
  let timeout = null;
  let withinResultArea = false;
  vm.shiftPressed = false;
  vm.selectedIndex = -1;
  vm.foundFiles = [];

  vm.$onInit = () => {};

  // Toggle for search results based on input field focus;
  vm.onBlur = () => {
    if (withinResultArea) {
      $('#file-search').focus();
      withinResultArea = false;
    } else {
      $('#file-search-results').fadeOut();
    }
  };

  vm.onFocus = () => {
    $('#file-search-results').fadeIn();
  };

  // Selection of result using arrow keys
  vm.onSelectionKeys = event => {
    if (event.key === 'ArrowUp') {
      event.preventDefault();
      event.stopPropagation();
      if (vm.selectedIndex >= 0) {
        vm.selectedIndex -= 1;
      } else {
        vm.selectedIndex = vm.foundFiles.length - 1;
      }
    }
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      event.stopPropagation();
      if (vm.selectedIndex < vm.foundFiles.length) {
        vm.selectedIndex += 1;
      } else {
        vm.selectedIndex = 0;
      }
    }
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      if (
        vm.selectedIndex >= 0 &&
        vm.selectedIndex < vm.foundFiles.length &&
        !vm.shiftPressed
      ) {
        const { url, id } = vm.foundFiles[vm.selectedIndex];
        $('#file-search').blur();
        if (url) $window.open(url, '_blank');
        else vm.selectFolder(id, 'build');
      }
    }
  };
  // Prevent blur when interacting with results;
  vm.mouseDown = () => {
    withinResultArea = true;
  };

  // Delayed search function which only requests
  // after no changes to input field within specified time;
  vm.inputChange = () => {
    if (vm.searchText === '') {
      vm.foundFiles = [];
    } else {
      vm.delayedSearch();
    }
  };

  vm.delayedSearch = () => {
    $timeout.cancel(timeout);
    timeout = $timeout(() => {
      if (vm.searchText.length > 0) {
        AssetsService.searchFiles(vm.searchText).then(files => {
          vm.foundFiles = files.map(file => ({
            cssClass: AssetsService.determineCssClass(file.filetype),
            ...file,
          }));
        });
      }
    }, 350);
  };

  // Redirecting based on user interaction
  vm.view = file => {
    withinResultArea = false;
    $('#file-search').blur();
    if (file.url) {
      $window.open(file.url, '_blank');
    } else {
      vm.selectFolder(file.id, 'build');
    }
  };
}

export {};
